<template>
	<!-- desktop -->
	<div
		ref="infoCard"
		@click="toggleInfo"
		class="fixed btn-default bottom-2 lg:left-1/2 z-[9999] hidden  w-[calc(40vw-1rem)] ml-[3vw] lg:ml-0 lg:max-w-[500px] -translate-x-1/2 cursor-pointer lg:block"
	>
		<header
			class="flex items-center justify-between text-lg transition-all duration-300 h-9"
			:class="{ 'mb-4 py-2 relative': expanded }"
		>
			<h1 class="text-sm text-slate-950 font-bold">{{ title }}</h1>
			<img
				v-if="!expanded"
				width="20"
				height="20"
				src="/images/icons/info.svg"
				alt="Info icon"
				class="w-auto h-full py-2.5"
			/>

			<button
				type="button"
				v-if="expanded"
				class="absolute -right-2 top-0.5 cursor-pointer p-1.5 hover:bg-slate-50 rounded-lg transition-all duration-200 group hover:scale-105 active:scale-95"
				aria-label="Close value driver modal"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="30"
					height="31"
					viewBox="0 0 30 31"
					fill="none"
					class="transition-transform duration-200 w-4 h-4"
				>
					<mask
						id="mask0_2008_32870"
						style="mask-type: alpha"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="30"
						height="31"
					>
						<rect y="0.5" width="30" height="30" fill="#D9D9D9" />
					</mask>
					<g mask="url(#mask0_2008_32870)">
						<path
							d="M8 24.25L6.25 22.5L13.25 15.5L6.25 8.5L8 6.75L15 13.75L22 6.75L23.75 8.5L16.75 15.5L23.75 22.5L22 24.25L15 17.25L8 24.25Z"
							fill="#6B6B6B"
							class="transition-colors duration-200 group-hover:fill-slate-700"
						/>
					</g>
				</svg>
			</button>
		</header>
		<section
			class="flex flex-col gap-4 overflow-hidden text-black transition-all duration-500 ease-in-out"
			:class="expanded ? 'h-[280px]' : 'h-0'"
		>
			<div class="h-full overflow-scroll text-sm">
				{{ content }}
			</div>
		</section>
	</div>
</template>
<script lang="js" src="./InfoCard"></script>
